import { useTheme } from '@emotion/react';
import { PostCard } from '../posts/post-card';
import { DEVICE_SCREENS_MAX_STRING } from '../../lib/consts';
import { Action, City } from '../../models';
import ArrowSVG from '../../public/img/angle-right.svg';
import { Link } from '../Link';

export function CatalogRecommends({
  title,
  viewed,
  currentCity,
}: {
  title: string;
  currentCity: City;
  viewed: { actions: Action[]; slug?: string };
}) {
  const theme = useTheme();
  if (viewed === undefined || !viewed?.actions?.length) {
    return null;
  }
  return (
    <div
      css={{
        width: '100%',
        marginBottom: '4rem',
        [DEVICE_SCREENS_MAX_STRING.md]: {
          marginBottom: '2rem',
        },
        [DEVICE_SCREENS_MAX_STRING.sm]: {
          padding: '0 8px',
        },
      }}
    >
      <div
        css={{
          marginBottom: 8,
        }}
      >
        <Link
          href={['', currentCity.url, 'compilations', viewed.slug, ''].join(
            '/'
          )}
        >
          <span
            css={{
              fontFamily: 'Montserrat',
              fontWeight: '700',
              fontSize: 34,
              color: theme.colors.black,
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              '&:hover': {
                color: '#f44336',
                fill: '#f44336',
                textDecoration: 'underline',
              },
              [DEVICE_SCREENS_MAX_STRING.sm]: {
                fontSize: 25,
                alignItems: 'flex-start',
              },
            }}
          >
            {title}
            <ArrowSVG
              css={{
                width: 30,
                height: 21,
                margin: '13px 0',
                [DEVICE_SCREENS_MAX_STRING.sm]: { height: 15 },
              }}
            />
          </span>
        </Link>
      </div>
      <div
        css={{
          display: 'flex',
          flexWrap: 'wrap',
          margin: '0 -8px',
          '.actions__item': {
            flex: '0 0 calc(100% / 3)',
            maxWidth: 316,
            [DEVICE_SCREENS_MAX_STRING.sm]: {
              maxWidth: '100%',
              width: '100%',
            },
          },
          [DEVICE_SCREENS_MAX_STRING.sm]: {
            maxWidth: '100vw',
            flexWrap: 'nowrap',
            overflow: 'auto',
            '.actions__item': {
              minWidth: 269,
            },
          },
        }}
      >
        {viewed.actions.map((item) => (
          <PostCard key={item.id} item={item} scroll />
        ))}
      </div>
    </div>
  );
}
